export default __webpack_public_path__ + "static/media/HoverNotice.1f94aea4.svg";